export default {
  PusherKey: '703d3a0be950105caaee',
  ISC_API_KEY: 'myapikey',
  GTM: 'GTM-KV53PFG',
  Segment: 'ymUHiduI8WgNZhGtB9P6eKlqd7sQlb4k',
  CustomerIOSiteID: 'cb04a5c94fd099c9a1aa',
  TrackingID: 'UA-66374966-17',
  Sentry: 'https://7f37ab73cd3646118f9de9ab763e89e0@sentry.instacarro.com/16',
  AmplitudeApiKey: 'ed769607b2ee80e9c29c220878f44471',
  ConfigCatSDKKey: 'ryjcCKO7c0iCF_n_oynJtQ/JRTsUlxi-kWhoIoOzWNwqw',
  baseURLs: {
    root: 'https://sandbox-api.instacarro.com',
    authentication: 'https://sandbox-api.instacarro.com/accounts',
    newAuthentication: 'https://account.sandbox.instacarro.com/v1/user',
    buyers: 'https://sandbox-api.instacarro.com/buyers/v2',
    dealers: 'https://sandbox-api.instacarro.com/dealers/v3',
    sales: 'https://sandbox-api.instacarro.com/buyers/v2',
    buyersV3: 'https://sandbox-api.instacarro.com/buyers/v3',
    accounts: 'https://sandbox-api.instacarro.com/accounts',
    metrics: 'http://sales-manager-metrics-service-sandbox.apps.instacarro.com',
    internals: 'https://sandbox-api.instacarro.com/internals',
    ninja_dashboard: 'https://sandbox-api.instacarro.com/ninja-dashboard-records/dashboard',
    mechanics: 'https://sandbox-api.instacarro.com/mechanics',
    logistics: 'https://sandbox-api.instacarro.com/logistics',
    baseIcApiDealers: 'https://sandbox-api.instacarro.com/ic-api-dealers',
    icApiDealers: 'https://sandbox-api.instacarro.com/ic-api-dealers/v1/dealers',
    auQueries: 'https://sandbox-api.instacarro.com/au_queries/v1',
    autobid: 'https://sandbox-api.instacarro.com/au_managements',
    preferences: 'https://notifications.sandbox.instacarro.com/order-cars',
    fincredit: 'https://sandbox-api.instacarro.com/fincredit_simulator_api/api',
    generateDoc: 'https://sandbox-api.instacarro.com/v1/pipelines/report/dealer/docs',
    calculator: 'https://sandbox-api.instacarro.com/preferences-calculator',
  },
  externalApps: {
    c2cAdmin: 'https://ec2c-backoffice.sandbox.instacarro.com/admin/login',
    c2c: 'https://c2c.sandbox.instacarro.com',
    newOffers: 'https://sandbox.app.instacarro.com',
  },
  MixpanelToken: 'f25cc12b33512b2983a01a2853b1780a',
  IndiqueLink: 'https://cupom.instacarro.com/lojistas',
  GA_Dimentions: {
    dealership_name: 'dimension3',
    auction_id: 'dimension5',
    dealership_id: 'dimension6',
    bid_amount: 'dimension7',
    bid_type: 'dimension8',
    dealership_email: 'dimension9',
    selectedCategory: 'dimension10',
    carResults: 'dimension11',
    interactionType: 'dimension12',
  },
  DOMAIN_APP: '.sandbox.leilao.instacarro.com',
  FINCREDIT_URL: 'https://sandbox.leilao.instacarro.com/fincredit/simule',
  UPCOMING_DISPUTES_IFRAME_BASE_URL: 'https://proximo-carro-alerta.lovable.app/',
  UPCOMING_DISPUTES_VEHICLES_URL:
    'https://camxqukqmiqccjlxjhjb.supabase.co/functions/v1/fetch-vehicles',
  // Configurações para cadastro de lojistas
  NEW_URL_API_INSTACARRO: 'https://sandbox-api.instacarro.com', // TODO: Atualizar com URL correta
  NEW_URL_API_INSTACARRO_API_KEY: 'YOUR_API_KEY_HERE', // TODO: Adicionar chave de API correta
  OneSignalSDK: 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js',
  OneSignalAppID: '2025b4be-97fb-4dba-8216-93c3c37d01f8',
};
